import React from "react";
import { Row } from "react-bootstrap";
import { Input, RadioGroup } from "../../../genericComponents";
import { pensionFormNames } from "../models/pensionFormNames";
import { required } from "../models/required";
import { defaultTwoOptions } from "../models/selects";

function RenderDocumentsDescription() {
  return (
    <Row>
      <Input
        label="Quais?"
        name={pensionFormNames.economicDependencyDocumentsDescription}
        maxLength={100}
      />
    </Row>
  );
}

function PensionRegister13(serverData) {
  const [hasDocuments, setHasDocuments] = React.useState(null);

  const economicDependencyDocuments = serverData?.economicDependencyDocuments;
  React.useEffect(() => {
    if (economicDependencyDocuments === defaultTwoOptions[0]) {
      setHasDocuments(true);
    }
  }, [economicDependencyDocuments, setHasDocuments]);

  return (
    <>
      <Row>
        <RadioGroup
          label="Você possui documentos, para comprovar a dependência econômica?"
          name={pensionFormNames.economicDependencyDocuments}
          options={defaultTwoOptions.map((item) => ({
            label: item,
            value: item,
          }))}
          required={required.default}
          inline
          onChange={(event, value) => {
            setHasDocuments(value === defaultTwoOptions[0]);
          }}
        />
      </Row>
      {hasDocuments === true ? <RenderDocumentsDescription /> : null}
    </>
  );
}

export default React.memo(PensionRegister13);
